import { render, staticRenderFns } from "./palletExchange.vue?vue&type=template&id=26923e9a"
import script from "./palletExchange.vue?vue&type=script&lang=js"
export * from "./palletExchange.vue?vue&type=script&lang=js"
import style0 from "./palletExchange.vue?vue&type=style&index=0&id=26923e9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports